module.exports = __webpack_public_path__ + "static/media/opensans-semibolditalic-webfont.e0be507a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-semibolditalic-webfont.woff2
// module id = 1009
// module chunks = 0